// src/app/services/contact.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ContactPayload {
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ContactService {
  private apiUrl = 'http://localhost:3000/api/contact'; // später Umgebungs-Variable

  constructor(private http: HttpClient) {}

  sendContact(data: ContactPayload): Observable<any> {
    return this.http.post(this.apiUrl, data);
  }
}
